<div class="col-lg-11 offset-lg-1 col-md-12 offset-md-0 datos-blq mx-auto mb-md-flex-dir-col">

    <div class="col-lg-4 col-md-4 col-sm-12 col-12 datos-blq-inner">
        <h2 class="counter">{{counterUp_params.data1 | number:'1.0-0' : 'es-ES'}}</h2>
        <span class="ms-1">
            <div [innerHTML]="counterUp_params.txt1">
            </div>
        </span>

    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 col-12 datos-blq-inner">
        <h2 class="counter">{{counterUp_params.data2 | number:'':'es-ES'}}</h2>
        <span class="ms-1">
            <div [innerHTML]="counterUp_params.txt2">
            </div>
        </span>

    </div>

    <div class="col-lg-4 col-md-4 col-sm-12 col-12 datos-blq-inner">
        <h2 class="counter">{{counterUp_params.data3 | number:'':'es-ES'}}</h2>
        <span class="ms-1">
            <div [innerHTML]="counterUp_params.txt3">
            </div>
        </span>

    </div>


</div>	
